import { Paper, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import logo from "../../vendor/atomic-one-logo.png";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  text-align: center;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Brand = styled.img`
  width: 160px;
  height: auto;
  margin-bottom: 20px;
`;

const LogoCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function CognitoCallback() {
  return (
    <React.Fragment>
      <Wrapper>
        <LogoCenter>
          <Brand src={logo} alt="atomic one" />
        </LogoCenter>
        <Helmet title="Password Updated" />
        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Password updated
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Your password has been set successfully. You can close this window.
        </Typography>
      </Wrapper>
    </React.Fragment>
  );
}

export default CognitoCallback;
